import { render, staticRenderFns } from "./InscripcionBeneficio.vue?vue&type=template&id=3738b204&scoped=true&"
import script from "./InscripcionBeneficio.vue?vue&type=script&lang=ts&"
export * from "./InscripcionBeneficio.vue?vue&type=script&lang=ts&"
import style0 from "./InscripcionBeneficio.vue?vue&type=style&index=0&id=3738b204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738b204",
  null
  
)

export default component.exports